import axiosApiClient from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/class";

class ClassesService {
  fetchClasses = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, "Error occured while fetching classes.");
    }
  };

  createClass = async (formData) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}`, formData);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, "Error occured while creating class.");
    }
  };

  editClass = async (formData) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}`, formData);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, "Error occured while editing class.");
    }
  };

  deleteClass = async (classId) => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/${classId}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, "Error occured while deleting class.");
    }
  };

  fetchEvents = async (jsonData) => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/events?from=${jsonData.from}&to=${jsonData.to}`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, "Error occured while fetching events.");
    }
  };

  deletePeriod = async (periodId) => {
    try {
      const response = await axiosApiClient.delete(
        `${BASE_URL}/period/${periodId}`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, "Error occured while deleting period.");
    }
  };

  createPeriod = async (periodData) => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/period`,
        periodData
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, "Error occured while creatingw period.");
    }
  };

  fetchTeacherClasses = async (classId) => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/${classId}/teachers`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, "Error occured while fetching teacherClasses.");
    }
  };

  fetchDashboardData = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/dashboard`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, "Error occured while fetching dashboard data.");
    }
  };
}

export default new ClassesService();
